"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canvaInitAttempted = canvaInitAttempted;
exports.canvaInitSucceeded = canvaInitSucceeded;
exports.canvaInitFailed = canvaInitFailed;
exports.acquireFileFromCanva = acquireFileFromCanva;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var FileApi = _interopRequireWildcard(require("FileManagerCore/api/Files"));

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _Constants = require("FileManagerCore/Constants");

var _notifications = require("../utils/notifications");

var _Folders = require("FileManagerCore/api/Folders");

var _Constants2 = require("../Constants");

function canvaInitAttempted() {
  return {
    type: _ActionTypes.CANVA_INIT_ATTEMPTED
  };
}

function canvaInitSucceeded() {
  return {
    type: _ActionTypes.CANVA_INIT_SUCCEEDED
  };
}

function canvaInitFailed() {
  return {
    type: _ActionTypes.CANVA_INIT_FAILED
  };
}

function canvaDownloadAttempted(_ref) {
  var meta = _ref.meta;
  return {
    type: _ActionTypes.DOWNLOAD_FROM_CANVA_ATTEMPTED,
    meta: meta
  };
}

function canvaDownloadFailed(_ref2) {
  var meta = _ref2.meta;
  return {
    type: _ActionTypes.DOWNLOAD_FROM_CANVA_FAILED,
    meta: meta
  };
}

function canvaDownloadSucceeded(_ref3) {
  var file = _ref3.file,
      meta = _ref3.meta;
  return {
    type: _ActionTypes.DOWNLOAD_FROM_CANVA_SUCCEEDED,
    file: file,
    meta: meta
  };
}

function getOrCreateCanvaFolder() {
  return function (dispatch, getState) {
    var state = getState();
    var folders = state.folders.get('objects');
    var existingCanvaFolder = folders.find(function (f) {
      return f.get('full_path') === _Constants2.CanvaFolderPath;
    });
    return existingCanvaFolder ? Promise.resolve(existingCanvaFolder) : (0, _Folders.add)({
      name: _Constants2.CanvaFolderName,
      parentId: null
    });
  };
}

function acquireFileFromCanva(canvaUrl, selectedFolder) {
  return function (dispatch, getState, httpClient) {
    var newFile = (0, _immutable.Map)({
      url: canvaUrl
    });

    var doAcquire = function doAcquire(targetFolder) {
      newFile = newFile.set('folder_id', targetFolder.get('id'));
      dispatch(canvaDownloadAttempted({
        meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
          name: 'Manage Files',
          usageTrackerJsName: 'fileManagerManageFiles',
          action: 'upload-canva-attempt'
        })
      }));
      return FileApi.downloadFromUrl(newFile, canvaUrl, httpClient).then(function (data) {
        dispatch(canvaDownloadSucceeded({
          file: data,
          meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
            name: 'Manage Files',
            usageTrackerJsName: 'fileManagerManageFiles',
            action: 'upload-canva-success'
          })
        }));
      }).catch(function () {
        dispatch(canvaDownloadFailed({
          meta: {
            notification: (0, _notifications.getCanvaDownloadFailedNotification)()
          }
        }));
      });
    };

    if (selectedFolder) {
      doAcquire(selectedFolder);
    } else {
      dispatch(getOrCreateCanvaFolder()).then(doAcquire);
    }
  };
}